/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Apis_Spec_UploadedInputs */



/**
* | output |
* | --- |
* | "The API description was stored." |
*
* @param {Integrations_Apis_Spec_UploadedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_apis_spec_uploaded = /** @type {((inputs?: Integrations_Apis_Spec_UploadedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Apis_Spec_UploadedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die API-Beschreibung wurde gespeichert.")
	return /** @type {LocalizedString} */ ("The API description was stored.")
});